import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getStorage, setStorage } from '../../../_metronic';
import { addUserConnection } from '../../crud/autouser/user.crud';

const CheckConnection = () => {
    const { userData } = useSelector((state) => state.auth);

    useEffect(() => {
        if (!userData?.id) {
            return;
        }

        if (getStorage('impersonatedBy') !== null) {
            return;
        }

        const handleConnection = async () => {
            const key = `connectionFor_${userData.email}`;

            if (getStorage(key) === null) {
                await addUserConnection();
                setStorage(key, Date.now());
                return;
            }

            const storageDate = new Date(Number(getStorage(key)));
            const currentDate = new Date();

            if (
                storageDate.getFullYear() !== currentDate.getFullYear() ||
                storageDate.getMonth() !== currentDate.getMonth() ||
                storageDate.getDate() !== currentDate.getDate()
            ) {
                await addUserConnection();
                setStorage(key, Date.now());
            }
        };

        const interval = setInterval(() => {
            // Catch ignored on purpose: the key is not stored on failure, so the next interval retries
            handleConnection().catch(() => {});
        }, 600000); // 10min

        handleConnection().catch(() => {});

        return () => {
            clearInterval(interval);
        };
    }, [userData]);

    return null;
};

export default CheckConnection;
